var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"item"},[_c('th',{staticClass:"label"},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('td',{staticClass:"value"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }